import Steps from './Steps';
import StepItem from './StepItem';

// export types
export type { StepsProps } from './Steps';
export type { StepItemProps } from './StepItem';

// export components
export { Steps, StepItem };
export default Steps;
